"use client";

import { useRouter } from "next/navigation";

export default function NotFoundButton() {
  const router = useRouter();

  return (
    <button
      onClick={() => router.back()}
      className="px-10 py-3 bg-black hover:bg-gray-800 text-white text-[14px] font-medium rounded-xl transition-colors shadow-sm"
    >
      Kembali
    </button>
  );
}